import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "las la-reply",
  style: {"font-size":"1.5em"}
}, null, -1)
const _hoisted_6 = { class: "card-body p-9" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên chức vụ:")
], -1)
const _hoisted_9 = { class: "col-3 d-flex align-items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "col-2 d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Tên viết tắt:")
], -1)
const _hoisted_13 = { class: "col-3 d-flex align-items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "d-flex mt-5 justify-content-start row" }
const _hoisted_16 = ["data-kt-indicator"]
const _hoisted_17 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_18 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_19 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "col-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.isCreating ? 'Tạo mới' : 'Chỉnh sửa') + " chức vụ ", 1)
      ]),
      _createVNode(_component_router_link, {
        to: "/quan-ly/chuc-vu/danh-sach",
        class: "btn btn-primary align-self-center"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_el_form, {
        ref: "formRef",
        class: "form",
        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"])),
        model: _ctx.form,
        rules: _ctx.rules
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_form_item, {
                prop: "name",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    name: "name"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                prop: "shortName",
                class: "mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.shortName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.shortName) = $event)),
                    name: "shortName",
                    onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"])),
              class: "btn btn-white me-3 col-2"
            }, " Xóa thông tin đã nhập "),
            _createElementVNode("button", {
              "data-kt-indicator": _ctx.loading ? 'on' : null,
              class: "btn btn-lg btn-primary col-2 me-4",
              type: "submit"
            }, [
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                    _createTextVNode(" Xác nhận "),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                    _createTextVNode(" Xin đợi ... "),
                    _hoisted_20
                  ]))
                : _createCommentVNode("", true)
            ], 8, _hoisted_16),
            _hoisted_21
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}